<template>
  <div>
    <b-navbar
      class="border-bottom"
      type="light">
      <b-navbar-brand>
        <font-awesome-icon :icon="['far', 'play-circle']" />
        {{ $t('titleNewRun') }}
      </b-navbar-brand>
    </b-navbar>
    <b-container class="pt-5">
      <h3>{{ $t('subTitleImportPage') }}</h3>
      <b-form-row class="mb-4 ml-auto mr-auto">
        <b-form-group>
          <span>{{ $t('descriptionSubTitleImportPage') }}</span>
        </b-form-group>
      </b-form-row>
      <b-form-row class="mb-4 ml-auto mr-auto">
        <b-col
          lg="6">
          <h4>{{ $t('importRunSelectAnalyser') }}</h4>
          <app-analyser-dropdown
            v-model="analyser"
            :state="validateState('analyser')"
            :allow-empty="false"
            @input="resetFileInputs"
            @optionsLoaded="selectDefault" />
        </b-col>
        <b-col
          lg="6">
          <h4>{{ fileToImportTitle }}</h4>
          <app-file-inputs
            ref="fileInputs"
            v-model="files"
            :state="validateState('files')"
            :max-number-of-inputs="analyser ? analyser.maxNumberOfFilesByRun : undefined" />
          <!-- GDPR reminder -->
          <div class="gdpr-reminder ml-2" style="margin-top: -12px;">
            {{ $t('common.gdpr-reminder') }}
          </div>
        </b-col>
        <b-container class="d-flex flex-row align-items-center justify-content-between p-4">
          <app-cancel-run :disabled="isLoading" />
          <b-button
            v-if="!isLoading"
            id="nextPageButton"
            class="text-right"
            @click="nextPage">
            {{ $t('next') }}
          </b-button>
          <b-button
            v-if="isLoading"
            class="flex-right-button"
            disabled>
            <b-spinner
              small
              type="grow" />
            Loading...
          </b-button>
        </b-container>
      </b-form-row>
    </b-container>
  </div>
</template>

<script>
import AnalyserDropdown from '../../common/AnalyserDropdown';
import { createRun } from '../../../service/GenefoxService';
import { required } from 'vuelidate/lib/validators';
import ValidationMixin from '../../../mixins/ValidationMixin';
import NotificationMixin from '@/mixins/NotificationMixin';
import FileInputs from './FileInputs';
import CancelRun from '../editor/CancelRun';

export default {
  components: {
    'app-analyser-dropdown': AnalyserDropdown,
    'app-file-inputs': FileInputs,
    'app-cancel-run': CancelRun
  },
  mixins: [
    ValidationMixin,
    NotificationMixin
  ],
  data() {
    return {
      oldRun: null,
      files: [],
      isLoading: false,
      analyser: undefined
    };
  },
  computed: {
    fileToImportTitle() {
      return this.analyser && this.analyser.maxNumberOfFilesByRun > 1 ? this.$t('importRunSelectFiles') : this.$t('importRunSelectFile');
    }
  },
  beforeMount() {
    this.initFormData();
  },
  methods: {
    initFormData() {
      this.$store.dispatch('runImport/resetRunImportState');
    },
    nextPage() {
      if (this.isValid() && this.files.length > 0) {
        this.isLoading = true;
        createRun(this.files, this.analyser)
          .then(run => {
            this.$store.dispatch('runImport/setCurrentRun', run);
            this.$store.dispatch('runImport/setFiles', this.files);
            this.$router.push({ name: 'run-creation', params: { id: run.id } });
          })
          .catch(error => {
            this.isLoading = false;
            this.showErrorNotification(this.$t('corruptedFileError'), error);
          });
      }
    },
    resetFileInputs() {
      this.touch('analyser');
      this.$refs.fileInputs.reset();
    },
    selectDefault(model) {
      this.analyser = model[0];
    }
  },
  validations: {
    analyser: {
      required
    },
    files: {
      containsAtLeastOneFile: files => files.length > 0
    }
  }
};
</script>
